import { Row, Col } from "antd";
import { AppPageHeader } from "components/AppPageHeader";
import { useDocumentTitle } from "hooks/usePageTitle";
import styled from "styled-components";

const WelcomeContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
  font-size: 2rem;
  font-weight: 500;
  color: #000000;
`;

export const HomePage = () => {
  useDocumentTitle("Home");
  
  return (
    <>
      <Row>
        <Col>
          <AppPageHeader title="" />
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <WelcomeContainer>
            Welcome to Handpickd
          </WelcomeContainer>
        </Col>
      </Row>
    </>
  );
};
